import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AccountingService } from '../service/accounting.service';
import {
  getReferenceDataSuccess,
} from './accounting.action';
import { selectYearMonthSpan } from './span.selector';
import {
  getMonthlyAccountStateError,
  getMonthlyAccountStateSuccess,
} from './monthly-accounts.action';
import { changeEndYearMonth, changeStartYearMonth } from './span.action';
import { hideLoading, showLoading } from '../../core/store/app.actions';

@Injectable({
  providedIn: 'root',
})
export class MonthlyAccountsEffects {

  constructor(
    private actions$: Actions,
    private accountingService: AccountingService,
    private store: Store<any>
  ) {
  }

  showLoadingEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        getReferenceDataSuccess,
        changeStartYearMonth,
        changeEndYearMonth
      ),
      map(() => showLoading())
    );
  });

  hideLoadingEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        getMonthlyAccountStateSuccess,
        getMonthlyAccountStateError
      ),
      map(() => hideLoading())
    );
  });

  getMonthlyAccountStateEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getReferenceDataSuccess, changeStartYearMonth, changeEndYearMonth),
      concatLatestFrom(() => [
        this.store.select(selectYearMonthSpan)
      ]),
      mergeMap(([, yearMonths]) =>
        this.accountingService.getMonthlyAccountState(yearMonths).pipe(
          map(monthlyAccountState => getMonthlyAccountStateSuccess({ monthlyAccountState })),
          catchError((error) => of(getMonthlyAccountStateError({ error })))
        )
      )
    );
  });
}
